import {
  Directive,
  effect,
  inject,
  Input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthStore } from '../stores/auth.store';

@Directive({
  selector: '[appIsNotReadOnly]',
  standalone: true,
})
export class IsNotReadOnlyDirective {
  private authStore = inject(AuthStore);
  private viewContainerRef = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef);

  private expectedPrivileges: string[] = [];

  private isVisible = false;

  @Input() set appIsNotReadOnly(privileges: string[]) {
    this.expectedPrivileges = privileges ?? [];
    this.evaluateVisibility();
  }

  constructor() {
    effect(() => {
      this.evaluateVisibility();
    });
  }

  private evaluateVisibility() {
    const user = this.authStore.currentUser();

    if (!user?.privileges?.length || !this.expectedPrivileges.length) {
      this.clearView();
      return;
    }

    const nonReadOnlyPrivileges = user.privileges
      .filter((p) => !p.flagReadOnly)
      .map((p) => p.actionCode);

    const privilegeSet = new Set(nonReadOnlyPrivileges);

    const hasPermission = this.expectedPrivileges.some((p) =>
      privilegeSet.has(p),
    );

    if (hasPermission) {
      this.renderView();
    } else {
      this.clearView();
    }
  }

  private renderView() {
    if (!this.isVisible) {
      this.isVisible = true;
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }

  private clearView() {
    this.isVisible = false;
    this.viewContainerRef.clear();
  }
}
